var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-1 bg-zinc-400 border border-zinc-400 hover:border-project-red hover:bg-project-red rounded text-white px-3.5 cursor-pointer klantRow",on:{"click":_vm.switchToSession}},[_vm._v(_vm._s(_vm.session.naam_compleet)),_c('i',{staticClass:"mdi mdi-square-edit-outline float-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }